module.exports = __webpack_public_path__ + "media/assets/staffs/jason_cheng-3273de157cb37ca057ee70025603f340.jpg";